import {Component} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-voiceCarrier-detail',
  templateUrl: './voiceCarrier-detail.component.html'
})
export class VoiceCarrierDetailComponent extends BaseComponent {
  voiceCarrier:any;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private authService:AuthService,
              private alertService:AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/voice/voiceCarriers/${id}`).subscribe(
            data => {
              this.setVoiceCarrier(data)
            }
          );
        }
      });
  }

  setVoiceCarrier(voiceCarrier:any) {
    this.voiceCarrier = voiceCarrier;
  }

  createNew() {
    this.voiceCarrier = {
      voiceCarrierType: 'SMARTCALL',
      enabled: true
    };
  }

  save() {
    if (!this.voiceCarrier.id) {
      this.http.post(`${this.env.e.url}/voice/voiceCarriers`, this.voiceCarrier)
        .subscribe(
          data => {
            this.setVoiceCarrier(data)
            this.alertService.info(`Created ${this.voiceCarrier.name}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/voice/voiceCarriers/${this.voiceCarrier.id}`, this.voiceCarrier)
        .subscribe(
          data => {
            this.setVoiceCarrier(data)
            this.alertService.info(`Updated`);
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/voice/voiceCarriers/${this.voiceCarrier.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted ${this.voiceCarrier.name}`);
          this.router.navigate(["/voiceCarriers"]);
        }
      );
  }

  hasRole(role:string) {
    if (!role) {
      return true;
    }
    return this.authService.hasRole(role);
  }
}
